module.exports = __webpack_public_path__ + "img/icon_power_ball.191712c6.svg";